<template>
  <div class="row autom" id="sms">
    <div class="purplebg">

    </div>
    <div class="left">
      <!-- <div class="row">
        <img class="icon" src="@/assets/icons/wheel.svg" />
      </div> -->

      <div class="row" >
        <a class="navbar-brand" href="#">
          <h1 class="left-title">
            <img class="quote-icon" src="@/assets/icons/qoute-white.png" />
            <br><b>To strengthen partnerships between the private schools and the public service sectors by fostering active participation in policy formulation and implementation.</b></h1>
        </a>
      </div>
    </div>
    <div class="right">
      <div class="row screenshots">
        <img class="dashboard" src="@/assets/screenshots/strengthen.png" />
        <!-- <img class="top-bar" src="@/assets/ui-screenshots/automotive/top-bar.svg" />
        <img class="sidebar" src="@/assets/ui-screenshots/automotive/sidebar.svg" />
        <img class="top-left-panel" src="@/assets/ui-screenshots/automotive/top-left-panel.svg" />
        <img class="top-mid-panel" src="@/assets/ui-screenshots/automotive/top-mid-panel.svg" />
        <img class="top-right-panel" src="@/assets/ui-screenshots/automotive/top-right-panel.svg" />
        <img class="bottom-panel" src="@/assets/ui-screenshots/automotive/bottom-panel.svg" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolMngtSys',
  props: {
    // msg: String
  },
  data() {
    return {
      showSms: false
    }
  },
  methods: {
    viewSMS() {
      this.showSms = this.showSms ? false : true; 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .purplebg{
    width: 100%;
    height: 45vh;
    margin-top: 6vh;
    z-index: -1;
    background: #8E9C8B;
    position: absolute;
  }

  .left-title{
    font-size: 2rem;
    font-family: MontserratLight, sans-serif;
    color: #fff;
    white-space: initial;
    text-align: left;
  }
  .quote-icon{
    max-width: 3rem;
  }
  #sms{
    padding-top: 50px;
  }
  .inputDemo{
    background: #fff;
    border: 1px solid #a9aba8;
    border-radius: 5px;
    width: 47%;
    margin-right: 10px;
  }
  .btn-area{
    padding-top: 5vh;
    justify-content: center;
  }
  .left-desc{
    font-size: 23px;
    font-family: MontserratRegular, sans-serif;
    color: #686868;
    width: 100%;
  }
  .viewFeatures{
    margin-top: 20px;
    font-size: 25px;
    font-family: MontserratBold, sans-serif;
    color: #000;
    cursor: pointer;
  }
  .autom{
      margin: 0;
  }
  .right{
      width: 50vw;
  }
  .left{
      width: 48vw;
      text-align: left;
      padding: 5vw 5vw;
  }

  .white, .strings{
      font-size: 1.5em;
  }

  .icon{
      width: auto;
      max-height: 30px;
  }

  h3{
      font-size: 1.7em;
      color: green;
      font-weight: 700;
  }

  .end{
      max-width: 31vw;
  }

  .screenshots{
      padding: 2vw;
  }

  .screenshots > img{
      /* position: absolute; */
  }

  .dashboard{
      width: 55.5vw;
      /* margin-top: 3.5vh; */
      right: 1vw;
  }
  .row > ul > li {
    list-style: none;
    font-family: MontserratBold, sans-serif;
    color: #818181;
  }
  .featuresDiv{
    min-height: 144.062px;
  }
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
  @media only screen and (max-width: 1024px) {
    .left, .right{
      width: 100%;
      display: inline-block;
    }
    
    .autom {
      padding-top: 120px;
      padding-bottom: 10px;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      /* optional */
      -webkit-box-align: start;
      -moz-box-align: start;
      -ms-flex-align: start;
      -webkit-align-items: flex-start;
      align-items: flex-start;
    }

    .autom .left {
      -webkit-box-ordinal-group: 2;
      -moz-box-ordinal-group: 2;
      -ms-flex-order: 2;
      -webkit-order: 2;
      order: 2;
    }

    .autom .right {
      -webkit-box-ordinal-group: 1;
      -moz-box-ordinal-group: 1;
      -ms-flex-order: 1;
      -webkit-order: 1;
      order: 1;
    }

    .screenshots > img{
      right: unset;
      display: block;
      position: relative;
      margin-top: 30px;
    }

    .dashboard{
      width: 90%;
    }

    .screenshots{
      display: block;
      text-align: -webkit-center;
    }

    .left{
      padding-left: 10vw;
      padding-right: 10vw;
    }

    .left-title{
      font-size: 30px;
      font-weight: 600 !important;
      white-space: break-spaces;
    }

    .left-desc{
      font-size: 25px;
    }

    .featuresDiv{
      min-height: 0px;
    }

    .purplebg{
      margin-top: 30px;
      height: 85vh;
    }
  }
</style>
